<template>
    <div class="search-wrapper top-search">
        <!--		<el-select v-model="selected" @change="changeOption()">-->
        <!--	      <el-option v-for="(item,index) in options" :key='index' :label="item" :value="index"></el-option>-->
        <!--	    </el-select>-->
        <input type="text" autocomplete="off" id="search" v-model="keywords" :placeholder="placeholderText[selected]"
               @keypress.enter="enterSearch($event)"/>
        <button id="btn" class="add-btn" @click="linkTo()">搜索</button>
        <div class="stock-list" v-show="isShow">
            <ul v-show="isNoData==1">
                <li><span>代码</span><span>名称</span><span>类型</span></li>
                <li v-if="isStockShow">
                    <a :title="searchList[0].stockName"
                       :href="'/stockIndex/stockIndex.html?stockCode='+searchList[0].stockCode">
                        <span>{{searchList[0].stockCode}}</span>
                        <span>{{searchList[0].stockName}}</span>
                        <span>股票</span>
                    </a>
                </li>
                <!--<li v-if="isFoundShow">
                    <a :title="searchList[1].foundName" :href="foundUrl+'fund/detail/info/'+searchList[1].innercode+'.html?index=1'" target="_blank">
                        <span>{{searchList[1].foundCode}}</span>
                        <span>{{searchList[1].foundName}}</span>
                        <span>基金</span>
                    </a>
                </li>-->
            </ul>
            <!--<div class="no-data" v-show="isNoData==0">没有找到相关股票/基金</div>-->
            <div class="no-data" v-show="isNoData==0">没有找到相关股票</div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import com from 'js/common.js';

    export default {
        data() {
            return {
//             foundUrl:window.foundUrl,
                isShow: false,
                isStockShow: true,
                isFoundShow: true,
                url: window.location.href,
                selected: 0,
                keywords: '',
                options: ['视频', '讲师'],
                placeholderText: ['请输入视频 讲师 资讯的关键字', '姓名'],
                linkUrl: ['search.html?keyword=', '/searchList/searchPerson.html?keywords='],
                searchList: [{
                    stockCode: '',
                    stockName: ''
                }, {
                    foundCode: '',
                    foundName: '',
                    innercode: ''
                }]
            };
        },
        computed: {
            isNoData: function () {
                if (this.keywords) {
//	    			if(this.isStockShow || this.isFoundShow){
	    			if(this.isStockShow){
	    				return 1;
	    			}else{
	    				return 0;
	    			}
	    		}else{
	    			this.isShow=false;
	    			this.searchList[0].stockCode='';
	    			this.searchList[0].stockName='';
//	    			this.searchList[1].companycode='';
	    			this.searchList[1].innercode='';
	    			
	    		}
	    	}
	    },
		mounted() {
			this.selected=parseInt(this.getUrlParamsByKey(this.url,'type')?this.getUrlParamsByKey(this.url,'type'):0);
		},
		methods: {
			changeOption:function(){
				this.keywords='';
				this.isShow=false;
			},
			linkTo:function($this){
				var _this=$this?$this:this;
				_this.isShow=true;
				var optsStock = {
					isLoading: true,
					loadingDom: 'div.top-search',
					success: function(result) {
						if(result.data && result.data.length) {
							_this.isShow=true;
							_this.isStockShow=true;
							_this.searchList[0].stockCode=result.data[0].stockCode;
							_this.searchList[0].stockName=result.data[0].stockName;
						} else {
							_this.isStockShow=false;
						}
					}
				},
				optsFound = {
					isLoading: true,
					loadingDom: 'div.top-search',
					success: function(result) {
						if(result.data && result.data.list.length) {
							_this.isShow=true;
							_this.isFoundShow=true;
							_this.searchList[1].foundCode=result.data.list[0].secucode;
							_this.searchList[1].foundName=result.data.list[0].secuabbr;
							_this.searchList[1].innercode=result.data.list[0].innercode;
						} else {
							_this.isFoundShow=false;
						}
					}
				};
				if(_this.keywords){
					if (_this.selected==2) {
						_this.getAjax('stock/codes.json', {keyword: _this.keywords}, optsStock);
//						_this.getAjaxCom1('secuMain/getFund','get',{pageNum:1,pageSize:1,search:_this.keywords},optsFound);
                    } else {
                        _this.isShow = false;
                        window.location.href = stockUrl + _this.linkUrl[_this.selected] + encodeURI(_this.keywords);
                    }
                } else {
                    _this.$message({
                        showClose: true,
                        message: _this.placeholderText[_this.selected],
                        type: 'warning'
                    });
                }
            },
            enterSearch: function ($event) {
                var $this = this;
                // if (!$this.selected) {
                // 	document.getElementsByClassName('stock-list')[0].style.display='block';
                // }
                $this.$options.methods.linkTo($this);
            }
        }
    }
</script>
<style lang="scss">
		div.search-wrapper {
			.el-select{
				background-color: #FFFFFF;
				position: relative;
				&:after{
					content: '';
					display: block;
					width: 0;
					height: 14px;
					border-right: 1px solid #dddddd;
					position: absolute;
					right: 0;
					top: 50%;
					margin-top: -7px;
				}
				.el-input{
					-webkit-user-select: none;
					-moz-user-select: none;
					-ms-user-select: none;
					user-select: none;
					.el-select__caret{
						width: 14px;
					    height: 14px;
					    margin-top: 12px;
					    margin-right: 9px;
						color: #333333;
						background: url(~images/arrow-up.png) no-repeat center center;
						text-indent: -9999px;
						-webkit-transition: -webkit-transform .3s;
					    transition: -webkit-transform .3s;
					    transition: transform .3s;
					    transition: transform .3s,-webkit-transform .3s;
					}
				}
				.el-input__inner{
					-webkit-border-radius: 0;
					-moz-border-radius: 0;
					border-radius: 0;
					border: 0;
					height: 36px;
					line-height: 36px;
					background: none;
					padding-left: 33px;
					color: #333333;
					-webkit-user-select: none;
					-moz-user-select: none;
					-ms-user-select: none;
					user-select: none;
				}
			}
		}
		
</style>
<style lang="scss" scoped="scoped">
    @import '~scss/mixin';

    * {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;

        .el-select-dropdown__item.selected {
            color: #ff3c42;
        }

        .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
            background-color: #f0f2f8;
        }

        div.search-wrapper {
            width: 489px !important;
            height: 38px;
            position: relative;

            .el-select {
                width: 96px;
                height: 38px;
                text-align: center;
                display: block;
                float: left;
                border-top-left-radius: 38px;
                -webkit-border-top-left-radius: 38px;
                -moz-border-radius-topleft: 38px;
                border-bottom-left-radius: 38px;
                -webkit-border-bottom-left-radius: 38px;
                -moz-border-radius-bottomleft: 38px;
                border-left: 1px solid #fe4741;
                border-top: 1px solid #fe4741;
                border-bottom: 1px solid #fe4741;
                overflow: hidden;
            }

            input[type=number],
            input[type=text] {
                border-left: 1px solid #fe4741;
                border-top-left-radius: 38px;
                border-bottom-left-radius: 38px;
                display: block;
                float: left;
                width: 399px;
                height: 38px;
                font-size: 14px;
                color: #333333;
                padding-left: 33px;
                padding-right: 13px;
                border-top: 1px solid #fe4741;
                border-bottom: 1px solid #fe4741;
                -moz-appearance: textfield;

                &::-webkit-input-placeholder {
                    color: #c3c3c3 !important;
                }

                &::-moz-placeholder {
                    color: #c3c3c3 !important;
                }

                &:-moz-placeholder {
                    color: #c3c3c3 !important;
                }

                &:-ms-input-placeholder {
                    color: #c3c3c3 !important;
                }

                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                    -webkit-appearance: none !important;
                    margin: 0;
                }

                &::-ms-clear {
                    display: none !important;
                }

                &:-ms-clear {
                    display: none !important;
                }
            }

            button.add-btn {
                cursor: pointer;
                display: block;
                float: left;
                vertical-align: top;
                text-align: center;
                height: 38px;
                line-height: 38px;
                width: 90px;
                font-size: 14px;
                color: #FFFFFF;
                background: url(~images/icon_searchbg.png) no-repeat center center;
                @include linear-gradient(right, #ff3c42, #ff643a);
                border-top-right-radius: 38px;
                -webkit-border-top-right-radius: 38px;
                -moz-border-radius-topright: 38px;
                border-bottom-right-radius: 38px;
                -webkit-border-bottom-right-radius: 38px;
                -moz-border-radius-bottomright: 38px;

                &.disabled {
                    cursor: not-allowed;
                }
            }

            div.stock-list {
                width: 303px;
                font-size: 14px;
                position: absolute;
                left: 96px;
                top: 35px;
                z-index: 10;
                background-color: #FFFFFF;
                -webkit-box-shadow: 0px 2px 2px #9a9a9a;
                -moz-box-shadow: 0px 2px 2px #9a9a9a;
                -ms-box-shadow: 0px 2px 2px #9a9a9a;
                box-shadow: 0px 2px 2px #9a9a9a;
                z-index: 999;

                &.stock-list-show {
                    position: absolute;
                    display: block;
                }

                ul {
                    li {
                        height: 36px;
                        line-height: 36px;
                        overflow: hidden;
                        padding: 0 20px;

                        &:first-child {
                            cursor: auto;
                            background-color: #f1f1f1;

                            & span {
                                color: #000000 !important;
                            }
                        }

                        &:hover {
                            background-color: #f7f7f7;
                        }

                        span {
                            display: inline-block;
                            width: 30%;
                            float: left;

                            &:first-child {
                                color: #ff3333;
                            }

                            &:nth-child(2) {
                                width: 55%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            &:last-child {
                                width: 15%;
                                text-align: right;
                            }
                        }
                    }
                }

                div.no-data {
                    margin-top: 35px;
                    margin-bottom: 35px;
                    text-align: center;
                    color: #333333;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/search.vue